import { FormControlLabel, Radio, RadioGroup as MuiRadioGroup } from "@mui/material";
import React, { ReactNode } from "react";

export interface IRadioOption<T extends string = string> {
    value: T;
    label?: ReactNode;
    disabled?: boolean;
}

export interface IRadioGroupProps<T extends string = string> {
    options: Array<IRadioOption<T>>;
    value: T | undefined;
    onChange?(evt: React.ChangeEvent<HTMLInputElement>, value: T): void;
    row?: boolean;
    sx?: object;
}

export const RadioGroup: React.FC<IRadioGroupProps> = ({ onChange, options, value, row, sx }) => {
    return (
        <MuiRadioGroup onChange={onChange} row={row} value={value ?? null} sx={sx}>
            {options.map((o) => (
                <FormControlLabel
                    key={o.value}
                    control={<Radio />}
                    disabled={o.disabled}
                    label={o.label ?? o.value}
                    value={o.value}
                />
            ))}
        </MuiRadioGroup>
    );
};
